import React, { useState, useEffect, useCallback } from 'react';

import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { toast } from 'react-toastify';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import FlexSelect from 'components/Inputs/FlexSelect';
import Pagination from 'components/Pagination';
import Loader from 'react-loader-spinner';
import HourMaskMMHHSS from '../../../../components/Inputs/HourMaskMMHHSS.js';
import DatePicker from '../../../../components/Inputs/DatePicker.js';
import Analytical from './tables/Analytical.js';
import { dateRules, hourRules } from './rulesValidation.js';

import csvImage from '../../../../assets/img/csv.png';
import xlsxImage from '../../../../assets/img/xlsx.png';
import { definedMessageGeneratedInPdfCsvDownloads } from '../../../Report/utils/definedMessageGeneratePdfCsv.js';
import { disabledDownloadButtonCsvAndPdf } from '../../../Report/utils/disabledDownloadButtonCsvAndPdf.js';

import { TotalRegister } from '../../../../components/TotalRegister/index.js';
import { format, startOfMonth } from 'date-fns';
import { Tooltip } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useGetAreas } from '../../GasOrder/hooks/useGetAreas.js';
import { useGetReason } from '../../GasOrder/hooks/useGetReason.js';
import { useGetSubReason } from '../../GasOrder/hooks/useGetSubReason.js';
import { useGetUser } from '../../GasOrder/hooks/useGetUser.js';
import { useGetPhase } from '../../GasOrder/hooks/useGetPhase.js';
import GasOrderListService from '../service/GasOrderListService.js';
import BranchService from '../../Branch/service/index';
import Service from '../service/Services.js';
import ServiceXlsx from '../service/ServicesXlsx.js';

import {
  Container,
  Row,
  Card,
  Form,
  Col,
  CardHeader,
  Button,
  CardBody,
  Input
} from 'reactstrap';

import {
  ImageButton,
  ImageSize
} from '../../../../assets/styles/image_style.js';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';

const GasOrderReport = () => {
  const { control, handleSubmit, errors, setValue, getValues } = useForm();
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  const [dataToSubmitDownloads, setDataToSubmitDownloads] = useState();
  const [loadingForm, setLoadingForm] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [page, setPage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [oportunnityList, setOportunnityList] = useState([]);
  const [quantitiesByProduct, setQuantitiesByProduct] = useState();
  const [dataToSend, setDataToSend] = useState({});
  const [subsidiariesList, setSubsidiariesList] = useState([]);
  const [typeOfFilteringByDate, setTypeOfFilteringByDate] =
    useState('Atendimento');

  const [messagemGenerateCsv, setMessagemGenerateCsv] = useState();
  const [messagemGenerateXlsx, setMessagemGenerateXlsx] = useState();

  //messagemGeneratePdfCsv
  useEffect(() => {
    const message = definedMessageGeneratedInPdfCsvDownloads(quantity, 0);

    setMessagemGenerateCsv(message.csvMessage);
    setMessagemGenerateXlsx(message.xlsxMessage);
  }, [quantity]);

  const { areaList } = useGetAreas();
  const { phaseList } = useGetPhase();
  const { reasonList } = useGetReason();
  const { subReasonList } = useGetSubReason();
  const { userList } = useGetUser();

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const formatData = (data) => {
    let splitData = data.split('/');
    let YY = splitData[2];
    let MM = splitData[1];
    let DD = splitData[0];
    let newDataEstoque = `${YY}-${MM}-${DD}`;
    return newDataEstoque;
  };

  useEffect(() => {
    BranchService.getAll()
      .then((response) => {
        if (response.data.data.length > 0) {
          let subsidiariesOptions = response.data.data.map((subsidiaries) => {
            return {
              subsidiaries: subsidiaries.id,
              label: `${subsidiaries.nome}-${subsidiaries.empresa}`
            };
          });

          setSubsidiariesList(subsidiariesOptions);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    getOpportunityList(page, dataToSend);
  }, [dataToSend, page]);

  function handlePageChange(page) {
    setPage(page);
    setLoadingTable(true);
    getOpportunityList(page, dataToSend);
  }

  function getOpportunityList(page = 1, formatedDataToSend) {
    if (Object.keys(formatedDataToSend).length === 0) {
      return;
    }
    GasOrderListService.getAllFormSearch(10, page, formatedDataToSend)
      .then((res) => {
        setQuantity(res.data.totalRegisters);
        setLoadingTable(false);
        if (res.data.totalRegisters === 0) {
          toast.info('Nenhuma oportunidade encontrada!', {
            autoClose: 3000,
            closeOnClick: true
          });
        } else {
          setOportunnityList(res?.data?.data?.oportunidades);
          setQuantitiesByProduct(res?.data?.data?.produtos);
        }
      })
      .catch((err) => {
        toast.error(err, {
          autoClose: 3000,
          closeOnClick: true
        });
        setLoadingTable(false);
      });
  }

  const downloadMediaCsv = useCallback(async () => {
    try {
      window.open(Service.getDownloadsCsvUrl(dataToSubmitDownloads), '_blank');
    } catch (err) {
      console.log('erro', err);
      toast.error(
        'Ops, ocorreu um erro. Por favor, entre em contato com o suporte',
        {
          autoClose: 3000,
          closeOnClick: true
        }
      );
    }
  }, [dataToSubmitDownloads]);

  const downloadMediaXlsx = useCallback(async () => {
    try {
      window.open(
        ServiceXlsx.getDownloadsXlsxUrl(dataToSubmitDownloads),
        '_blank'
      );
    } catch (err) {
      console.log('erro', err);
      toast.error(
        'Ops, ocorreu um erro. Por favor, entre em contato com o suporte',
        {
          autoClose: 3000,
          closeOnClick: true
        }
      );
    }
  }, [dataToSubmitDownloads]);

  const getDataDTO = useCallback(
    async (data) => {
      let dataToSend;
      dataToSend = {
        ...data,
        dataInicial: data.dataInicial,
        dataFinal: data.dataFinal,
        horaInicial: data.horaInicial,
        horaFinal: data.horaFinal
      };
      Object.keys(dataToSend).forEach((key) => {
        if (dataToSend[key] === '') {
          delete dataToSend[key];
        }
      });
      setDataToSubmitDownloads(dataToSend);
      return dataToSend;
    },
    [toISOFormat]
  );

  function onSubmit(event) {
    let formatedDataToSend = {
      buscaNumero: event.buscaNumero,
      buscaProtocoloExterno: event.buscaProtocoloExterno,
      buscaConta: event.buscaConta,
      pesquisa: event.search === undefined ? '' : event.search,
      tipoDeData: typeOfFilteringByDate,
      dataInicial: formatData(event.dateBegin),
      horaInicial: event.timeStart,
      dataFinal: formatData(event.dateEnd),
      horaFinal: event.timeEnd,
      areaId: event.responsableArea,
      motivoId: event.motive,
      submotivoId: event.subMotive,
      modalidade: event.modality,
      filialId: event.subsidiaries,
      responsavel: event.opportunityProprietary,
      faseId:
        event.oportunnityPhase === undefined ? '' : event.oportunnityPhase,
      codRegional: event.regional === undefined ? '' : event.regional.join(','),
      diasDePagamento:
        event.numberOfPaymentDays === '' ? '' : +event.numberOfPaymentDays
    };

    const mapNomeRegional = new Map([
      ['1192,1220,1189,1209,1193,1191', 'NORDESTE I'],
      ['1205,1196,1211,1222,1206,1195,1194,1203,1204', 'NORDESTE II'],
      [
        '1227,1218,1210,1216,1201,1239,1233,1198,1221,1228,1212,1226,1197,1199,1229,1200,1232,1213,1215',
        'SUDESTE/CO'
      ],
      ['1231,1202,1208,1234,1207,1219,1230,1190', 'NORTE'],
      ['1224,1217,1214,1237,1236,1238,1223', 'SUL']
    ]);

    if (formatedDataToSend.codRegional) {
      const nomeRegionais = [];
      event.regional.forEach((regional) => {
        nomeRegionais.push(mapNomeRegional.get(regional));
      });
      formatedDataToSend.nomeRegionais = nomeRegionais.join(',');
    }

    getDataDTO(formatedDataToSend);
    setLoadingTable(true);
    setDataToSend(formatedDataToSend);
    setPage(1);
  }

  const getDateBegin = () => {
    const date = new Date();
    const firstDayMonth = new Date(
      date.getFullYear('pt-br'),
      date.getMonth('pt-br'),
      1
    );
    const dateBegin = format(startOfMonth(firstDayMonth), 'dd/LL/yyyy');
    return dateBegin;
  };

  const toISOFormat = useCallback(async (dateTimeString, bar = false) => {
    const [date] = dateTimeString.split(' ');
    const [DD, MM, YYYY] = date.split('/');
    if (bar) return `${MM}/${DD}/${YYYY}`;
    return `${MM}-${DD}-${YYYY}`;
  }, []);

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        returnPath="/admin/dashboard"
        showBackArrow="not"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3>Lista de Oportunidades</h3>
                </CardHeader>
                <CardBody>
                  {loadingForm ? (
                    <Row className="justify-content-md-center">
                      <Loader
                        type="TailSpin"
                        color={systemConfiguration.primary_color}
                        height={100}
                        width={100}
                      />
                    </Row>
                  ) : (
                    <>
                      <Form
                        className="needs-validation mb-0"
                        onSubmit={handleSubmit(onSubmit)}
                        style={{ marginBottom: '2rem' }}
                      >
                        <Row className="mb-3">
                          <Col md="4">
                            <label className="form-control-label">
                              Protocolo FLEXUC{' '}
                            </label>
                            <Controller
                              as={
                                <Input fieldName="buscaNumero" placeholder="" />
                              }
                              control={control}
                              name="buscaNumero"
                              defaultValue=""
                            />
                          </Col>
                          <Col md="4">
                            <label className="form-control-label">
                              Protocolo Externo
                            </label>
                            <Controller
                              as={
                                <Input
                                  fieldName="buscaProtocoloExterno"
                                  placeholder=""
                                />
                              }
                              control={control}
                              name="buscaProtocoloExterno"
                              defaultValue=""
                            />
                          </Col>
                          <Col md="4">
                            <label className="form-control-label">
                              CNPJ/CPF ou Razão Social ou Email
                            </label>
                            <Controller
                              as={
                                <Input fieldName="buscaConta" placeholder="" />
                              }
                              control={control}
                              name="buscaConta"
                              defaultValue=""
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="12">
                            <label className="form-control-label">
                              Tipo de data para pesquisa
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={[
                                    {
                                      label: 'Atendimento',
                                      typeOfFilteringByDate: 'Atendimento'
                                    },
                                    {
                                      label: 'Agendamento',
                                      typeOfFilteringByDate: 'Agendamento'
                                    }
                                  ]}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={(fieldName, value) => {
                                    setValue(fieldName, value);
                                    if (
                                      value === 'Agendamento' ||
                                      value === 'Atendimento'
                                    ) {
                                      setTypeOfFilteringByDate(value);
                                    }
                                  }}
                                  closeMenuOnSelect={true}
                                  isClearable={false}
                                  fieldName="typeOfFilteringByDate"
                                  labelName="label"
                                  valueName="typeOfFilteringByDate"
                                />
                              )}
                              control={control}
                              name="typeOfFilteringByDate"
                              fieldName="typeOfFilteringByDate"
                              defaultValue={'Atendimento'}
                            />
                          </Col>
                        </Row>
                        {typeOfFilteringByDate === 'Atendimento' ? (
                          <>
                            <Row className="mb-3">
                              <Col md="6">
                                <label className="form-control-label">
                                  Data inicial(Atendimento)*
                                </label>
                                <Controller
                                  render={(props) => (
                                    <DatePicker
                                      fieldName="dateBegin"
                                      valueController={setValue}
                                      defaultValue={props.value}
                                    />
                                  )}
                                  control={control}
                                  name="dateBegin"
                                  rules={dateRules}
                                  defaultValue={getDateBegin()}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="dateBegin"
                                  render={({ message }) =>
                                    errorFormMessage(message)
                                  }
                                />
                              </Col>

                              <Col md="6">
                                <label className="form-control-label">
                                  Hora inicial(Atendimento)*
                                </label>
                                <Controller
                                  render={(props) => (
                                    <HourMaskMMHHSS
                                      valueController={setValue}
                                      fieldName="timeStart"
                                      value={props.value}
                                    />
                                  )}
                                  control={control}
                                  name="timeStart"
                                  rules={hourRules}
                                  defaultValue="00:00:00"
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="timeStart"
                                  render={({ message }) =>
                                    errorFormMessage(message)
                                  }
                                />
                              </Col>
                            </Row>

                            <Row className="mb-3">
                              <Col md="6">
                                <label className="form-control-label">
                                  Data final(Atendimento)*
                                </label>
                                <Controller
                                  render={(props) => (
                                    <DatePicker
                                      fieldName="dateEnd"
                                      valueController={setValue}
                                      defaultValue={props.value}
                                    />
                                  )}
                                  control={control}
                                  name="dateEnd"
                                  defaultValue={new Date().toLocaleDateString(
                                    'pt-br'
                                  )}
                                  rules={{
                                    ...dateRules,
                                    validate: async (value) => {
                                      if (
                                        new Date(
                                          await toISOFormat(value, true)
                                        ) <
                                        new Date(
                                          await toISOFormat(
                                            getValues()['dateBegin'],
                                            true
                                          )
                                        )
                                      ) {
                                        return 'A data final não pode ser anterior à inicial!';
                                      } else {
                                        return true;
                                      }
                                    }
                                  }}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="dateEnd"
                                  render={({ message }) =>
                                    errorFormMessage(message)
                                  }
                                />
                              </Col>

                              <Col md="6">
                                <label className="form-control-label">
                                  Hora final(Atendimento)*
                                </label>
                                <Controller
                                  render={(props) => (
                                    <HourMaskMMHHSS
                                      valueController={setValue}
                                      fieldName="timeEnd"
                                      value={props.value}
                                    />
                                  )}
                                  control={control}
                                  name="timeEnd"
                                  rules={hourRules}
                                  defaultValue="23:59:59"
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="timeEnd"
                                  render={({ message }) =>
                                    errorFormMessage(message)
                                  }
                                />
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <>
                            <Row className="mb-3">
                              <Col md="6">
                                <label className="form-control-label">
                                  Data inicial(Agendamento)*
                                </label>
                                <Controller
                                  render={(props) => (
                                    <DatePicker
                                      fieldName="dateBegin"
                                      valueController={setValue}
                                      defaultValue={props.value}
                                    />
                                  )}
                                  control={control}
                                  name="dateBegin"
                                  rules={dateRules}
                                  defaultValue={getDateBegin()}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="dateBegin"
                                  render={({ message }) =>
                                    errorFormMessage(message)
                                  }
                                />
                              </Col>

                              <Col md="6">
                                <label className="form-control-label">
                                  Hora inicial(Agendamento)*
                                </label>
                                <Controller
                                  render={(props) => (
                                    <HourMaskMMHHSS
                                      valueController={setValue}
                                      fieldName="timeStart"
                                      value={props.value}
                                    />
                                  )}
                                  control={control}
                                  name="timeStart"
                                  rules={hourRules}
                                  defaultValue="00:00:00"
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="timeStart"
                                  render={({ message }) =>
                                    errorFormMessage(message)
                                  }
                                />
                              </Col>
                            </Row>

                            <Row className="mb-3">
                              <Col md="6">
                                <label className="form-control-label">
                                  Data final(Agendamento)*
                                </label>
                                <Controller
                                  render={(props) => (
                                    <DatePicker
                                      fieldName="dateEnd"
                                      valueController={setValue}
                                      defaultValue={props.value}
                                    />
                                  )}
                                  control={control}
                                  name="dateEnd"
                                  defaultValue={new Date().toLocaleDateString(
                                    'pt-br'
                                  )}
                                  rules={{
                                    ...dateRules,
                                    validate: async (value) => {
                                      if (
                                        new Date(
                                          await toISOFormat(value, true)
                                        ) <
                                        new Date(
                                          await toISOFormat(
                                            getValues()['dateBegin'],
                                            true
                                          )
                                        )
                                      ) {
                                        return 'A data final não pode ser anterior à inicial!';
                                      } else {
                                        return true;
                                      }
                                    }
                                  }}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="dateEnd"
                                  render={({ message }) =>
                                    errorFormMessage(message)
                                  }
                                />
                              </Col>

                              <Col md="6">
                                <label className="form-control-label">
                                  Hora final(Agendamento)*
                                </label>
                                <Controller
                                  render={(props) => (
                                    <HourMaskMMHHSS
                                      valueController={setValue}
                                      fieldName="timeEnd"
                                      value={props.value}
                                    />
                                  )}
                                  control={control}
                                  name="timeEnd"
                                  rules={hourRules}
                                  defaultValue="23:59:59"
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="timeEnd"
                                  render={({ message }) =>
                                    errorFormMessage(message)
                                  }
                                />
                              </Col>
                            </Row>
                          </>
                        )}
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Responsável
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={userList}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={setValue}
                                  closeMenuOnSelect={true}
                                  isClearable={true}
                                  fieldName="opportunityProprietary"
                                  labelName="label"
                                  valueName="opportunityProprietary"
                                />
                              )}
                              control={control}
                              name="opportunityProprietary"
                              fieldName="opportunityProprietary"
                              defaultValue=""
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">Área</label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={areaList}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={setValue}
                                  isClearable={true}
                                  closeMenuOnSelect={true}
                                  fieldName="responsableArea"
                                  labelName="label"
                                  valueName="responsableArea"
                                />
                              )}
                              control={control}
                              name="responsableArea"
                              defaultValue=""
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md="4">
                            <label className="form-control-label">Motivo</label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={reasonList}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={setValue}
                                  isClearable={true}
                                  closeMenuOnSelect={true}
                                  fieldName="motive"
                                  labelName="label"
                                  valueName="motive"
                                />
                              )}
                              control={control}
                              name="motive"
                              defaultValue=""
                            />
                          </Col>
                          <Col md="4">
                            <label className="form-control-label">
                              SubMotivo
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={subReasonList}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={setValue}
                                  isClearable={true}
                                  closeMenuOnSelect={true}
                                  fieldName="subMotive"
                                  labelName="label"
                                  valueName="subMotive"
                                />
                              )}
                              control={control}
                              name="subMotive"
                              defaultValue=""
                            />
                          </Col>
                          <Col md="4">
                            <label className="form-control-label">
                              Modalidade
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={[
                                    {
                                      label: 'CIF',
                                      modality: 'CIF'
                                    },
                                    {
                                      label: 'FOB',
                                      modality: 'FOB'
                                    }
                                  ]}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={setValue}
                                  isClearable={true}
                                  closeMenuOnSelect={true}
                                  fieldName="modality"
                                  labelName="label"
                                  valueName="modality"
                                />
                              )}
                              control={control}
                              name="modality"
                              defaultValue=""
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">Status</label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={phaseList}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={setValue}
                                  closeMenuOnSelect={true}
                                  isClearable={true}
                                  fieldName="oportunnityPhase"
                                  labelName="label"
                                  valueName="oportunnityPhase"
                                />
                              )}
                              control={control}
                              name="oportunnityPhase"
                              fieldName="oportunnityPhase"
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">Filial</label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={subsidiariesList}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={setValue}
                                  closeMenuOnSelect={true}
                                  isClearable={true}
                                  fieldName="subsidiaries"
                                  labelName="label"
                                  valueName="subsidiaries"
                                />
                              )}
                              control={control}
                              name="subsidiaries"
                              fieldName="subsidiaries"
                              defaultValue=""
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Regional
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={[
                                    {
                                      label: 'NORDESTE 1',
                                      regional: '1192,1220,1189,1209,1193,1191'
                                    },
                                    {
                                      label: 'NORDESTE 2',
                                      regional:
                                        '1205,1196,1211,1222,1206,1195,1194,1203,1204'
                                    },
                                    {
                                      label: 'SUDESTE',
                                      regional:
                                        '1227,1218,1210,1216,1201,1239,1233,1198,1221,1228,1212,1226,1197,1199,1229,1200,1232,1213,1215'
                                    },
                                    {
                                      label: 'NORTE',
                                      regional:
                                        '1231,1202,1208,1234,1207,1219,1230,1190'
                                    },
                                    {
                                      label: 'SUL',
                                      regional:
                                        '1224,1217,1214,1237,1236,1238,1223'
                                    }
                                  ]}
                                  isMulti={true}
                                  value={props.value}
                                  valueController={setValue}
                                  isClearable={true}
                                  closeMenuOnSelect={true}
                                  fieldName="regional"
                                  labelName="label"
                                  valueName="regional"
                                />
                              )}
                              control={control}
                              name="regional"
                              defaultValue={[]}
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Quantidade de dias pagamento
                            </label>

                            <Controller
                              as={<Input />}
                              control={control}
                              name="numberOfPaymentDays"
                              defaultValue=""
                            />
                          </Col>
                        </Row>

                        <div className="d-flex flex-row justify-content-between align-items-center">
                          <Button
                            style={{
                              ...buttonStyle(systemConfiguration.primary_color)
                            }}
                            type="submit"
                          >
                            Buscar
                          </Button>

                          <Row
                            className="mb-0"
                            style={{ flexDirection: 'row-reverse' }}
                          >
                            <Col md="md-4" style={{ margin: '1rem' }}>
                              <button
                                id="button_csv"
                                style={ImageButton}
                                onClick={downloadMediaCsv}
                                type="button"
                                disabled={disabledDownloadButtonCsvAndPdf(
                                  'csv',
                                  quantity,
                                  0
                                )}
                              >
                                <Tooltip
                                  title={
                                    <p style={{ fontSize: '14px' }}>
                                      {messagemGenerateCsv}
                                    </p>
                                  }
                                  arrow
                                >
                                  <img
                                    src={csvImage}
                                    alt="csv"
                                    style={ImageSize}
                                  />
                                </Tooltip>
                              </button>

                              <button
                                id="button_xlsx"
                                style={ImageButton}
                                onClick={downloadMediaXlsx}
                                type="button"
                                disabled={disabledDownloadButtonCsvAndPdf(
                                  'xlsx',
                                  quantity,
                                  0
                                )}
                              >
                                <Tooltip
                                  title={
                                    <p style={{ fontSize: '14px' }}>
                                      {messagemGenerateXlsx}
                                    </p>
                                  }
                                  arrow
                                >
                                  <img
                                    src={xlsxImage}
                                    alt="xlsx"
                                    style={ImageSize}
                                  />
                                </Tooltip>
                              </button>
                            </Col>
                          </Row>
                        </div>
                      </Form>
                    </>
                  )}
                  {loadingTable ? (
                    <Row className="justify-content-md-center">
                      <Loader
                        type="TailSpin"
                        color={systemConfiguration.primary_color}
                        height={100}
                        width={100}
                      />
                    </Row>
                  ) : (
                    quantity !== 0 && (
                      <>
                        <TotalRegister totalRegister={quantity} />
                        <Analytical
                          dataOportunnityList={oportunnityList}
                          areaList={areaList}
                          phaseList={phaseList}
                          reasonList={reasonList}
                          subReasonList={subReasonList}
                        />

                        <div>
                          <p className="my-0 font-weight-bold">
                            <span>P5: </span>
                            {quantitiesByProduct?.find((n) => n.name === 'P5')
                              ?.quantidade ?? 0}
                          </p>
                          <p className="my-0 font-weight-bold">
                            P8:{' '}
                            {quantitiesByProduct?.find((n) => n.name === 'P8')
                              ?.quantidade ?? 0}
                          </p>
                          <p className="my-0 font-weight-bold">
                            P13:{' '}
                            {quantitiesByProduct?.find((n) => n.name === 'P13')
                              ?.quantidade ?? 0}
                          </p>
                          <p className="my-0 font-weight-bold">
                            P20:{' '}
                            {quantitiesByProduct?.find((n) => n.name === 'P20')
                              ?.quantidade ?? 0}
                          </p>
                          <p className="my-0 font-weight-bold">
                            P45:{' '}
                            {quantitiesByProduct?.find((n) => n.name === 'P45')
                              ?.quantidade ?? 0}
                          </p>
                          <p className="my-0 font-weight-bold">
                            Granel:{' '}
                            {quantitiesByProduct?.find(
                              (n) => n.name === 'Granel'
                            )?.quantidade ?? 0}
                          </p>
                        </div>

                        <Pagination
                          activePage={page}
                          totalItemsCount={quantity}
                          onChange={handlePageChange.bind(this)}
                        />
                      </>
                    )
                  )}
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default GasOrderReport;
